import { gql } from '@apollo/client';

export const GET_INFO_TO_CONFIRM = gql`
  query myUser {
    myUser {
      id
      confirmUserInfo
      mobilePromptReminder
      email
      firstName
      lastName
      isMasaMember
      state {
        id
        name
      }
      memberAgency {
        id
        name
      }
      mobileNumber
      smsOptIn
    }
    states {
      value: id
      label: name
    }
  }
`;

export const UPDATE_USER_INFO = gql`
  mutation confirmUserInfo($email: Email!, $state: ID!, $memberAgency: ID!) {
    confirmUserInfo(data: { email: $email, state: $state, memberAgency: $memberAgency }) {
      code
      message
      success
    }
  }
`;
